import React, { useState, useEffect } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
// import "./index.scss";
import { getValue, setValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import { QueryRequestHelper } from "@_common/query-request-helper";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { countKeysWithValues, json2array, textCapitalize } from "@_common/text-helpers";
import Loader from "@components/common/Loader";
import { convertDate } from "@_common/date-helpers";
import {
  getChildEntityGroupsIC,
  getEntityGroupsIC,
  getDashboardSelfActivityIC
} from "@services/internal-compliance.service";
import SearchHeader from "@components/common/SearchHeader";
import DashboardFilterForm from "@components/common/DashboardFilterForm";
import { formatText } from "@_common/format-text";
import AssignedSvgComponent from "../../../../assets/svg-components/assigned";
import PosingSvgComponent from "../../../../assets/svg-components/posing";
import CompliedSvgComponent from "../../../../assets/svg-components/complied";
import NonCompliedSvgComponent from "../../../../assets/svg-components/non-complied";
import DelayedSvgComponent from "../../../../assets/svg-components/delayed";
import DelayReportedSvgComponent from "../../../../assets/svg-components/delay-reported";
import ReopenedSvgComponent from "../../../../assets/svg-components/reopened";
import OverdueSvgComponent from "../../../../assets/svg-components/overdue";
import UpcomingSvgComponent from "../../../../assets/svg-components/upcoming";
import DueTodaySvgComponent from "../../../../assets/svg-components/due-today";
import TotalSvgComponent from "../../../../assets/svg-components/total";
import SubmissionApprovalSvgComponent from "../../../../assets/svg-components/submission-approval";
import PendingApprovalSvgComponent from "../../../../assets/svg-components/pending-approval";
import DashboardSvgComponent from "../../../../assets/svg-components/left-menu/dashboard";
import RightMenuHeaders from "@components/common/RightMenuHeaders";

export default function ICDashboardActivity(props: any) {
  const navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState({});
  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const [approval_stats, setApprovalStats] = useState([]);
  const [complianceReports, setComplianceReports] = useState([]);
  const [selfActivity, setSelfActivity] = useState([]);

  const random_rgba = () => {
    const colors = [
      "#E8F0FE",
      "#F0F9F6",
      "#FDF9F4",
      "#D8E6FE",
      "#FBF2F4",
      "#FFFCFC",
      "#FDFEFF",
    ];
    var random_color: any = colors[Math.floor(Math.random() * colors.length)];
    return random_color;
  };

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getHeaderList(paramsObj, 0);
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);
    }
  }, [props.permissionAPITriggered]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      }

      if (params.firstDay && params.lastDay) {
        // setDate(new Date(params.date));
        var firstDay = new Date(params.firstDay);
        var lastDay = new Date(params.lastDay);
        setFirstDay(firstDay);
        setLastDay(lastDay);
      }

      let paramObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(params, `level${i}`, "")) {
          paramObj[`level${i}`] = getValue(params, `level${i}`, "");
        }
      }
      setParamsObj(paramObj);
      getHeaderList(paramObj, 0);
      if (Object.keys(paramObj).length > 0) {
        setFilterVisibility(true);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  const normalizeKeys = (obj: Record<string, any>) => {
  const keyMap: Record<string, string> = {
    EVENT_NOT_OCCURED: "EVENT_NOT_OCCURRED",
  };

  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[keyMap[key] || key] = value;
    return acc;
  }, {} as Record<string, any>);
};

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getData = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
      };
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let levelObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(paramsObj, `level${i}`, "")) {
          levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
            "_"
          )[0];
        }
      }
      setIsLoading(true);
      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
      let resp = await getDashboardSelfActivityIC(queryRequest);
      console.log(resp,"ppp11")
      if (resp) {
        setData(getValue(resp, `data`, {}));
        let approval_stats = json2array(
          getValue(resp, `data.approval_stats`, {})
        );
        let approval = approval_stats.map((item: any) => ({
          ...item,
          activity: Object.keys(item)[0],
        }));
        let compliance_reports = json2array(
          getValue(resp, `data.compliance_reports`, {})
        );
        let compliance = compliance_reports.map((item: any) => ({
          ...item,
          activity: Object.keys(item)[0],
        }));
  
        let self_activity = json2array(
         normalizeKeys(getValue(resp, `data.self_activity`, {}))
        );
        let self = self_activity.map((item: any) => ({
          ...item,
          activity: Object.keys(item)[0],
        }));
        setApprovalStats(approval);
        setComplianceReports(compliance);
        setSelfActivity(self);
        setIsLoading(false);
      } 
      else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getDataParamsObj = async (paramsObj: object) => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
      };
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let levelObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(paramsObj, `level${i}`, "")) {
          levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
            "_"
          )[0];
        }
      }
      setIsLoading(true);
      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
      let resp = await getDashboardSelfActivityIC(queryRequest);
      if (resp) {
        setData(getValue(resp, `data`, {}));
        let approval_stats = json2array(
          getValue(resp, `data.approval_stats`, {})
        );
        let approval = approval_stats.map((item: any) => ({
          ...item,
          activity: Object.keys(item)[0],
        }));
        let compliance_reports = json2array(
          getValue(resp, `data.compliance_reports`, {})
        );
        let compliance = compliance_reports.map((item: any) => ({
          ...item,
          activity: Object.keys(item)[0],
        }));
        let self_activity = json2array(
          getValue(resp, `data.self_activity`, {})
        );
        let self = self_activity.map((item: any) => ({
          ...item,
          activity: Object.keys(item)[0],
        }));
        setApprovalStats(approval);
        setComplianceReports(compliance);
        setSelfActivity(self);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* ---------------------------  Entity Mapping Filters  ----------------------------- */


  const [headerList, setHeaderList] = useState([]);
  const [headerLoading, setHeaderLoading] = useState(true);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroupsIC(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.icEntityGroups`, []));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.icEntityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.icEntityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.icEntityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        // delete params[`checkpoint_id[]`];
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
        if (getValue(list, `length`, 0) > 0) {
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.icEntityGroups`,
              []
            ).filter(
              (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
            );
            if (_index === index)
              return getEntityList(
                getValue(findNextLevelInfo, `[${0}].id`, ""),
                item.split("_")[0],
                "",
                index
              );
          });
        } else {
          getEntityList(
            getValue(resp, `data.icEntityGroups[${0}].id`, ""),
            null,
            "",
            index
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const getEntityGroupsUponSelection = async (
    paramsObj: object,
    index: number
  ) => {
    let list =
      Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
    if (getValue(list, `length`, 0) > 0) {
      list.map((item: any, _index: number) => {
        let findNextLevelInfo = headerList.filter(
          (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
        );
        if (_index === index)
          return getEntityList(
            getValue(findNextLevelInfo, `[${0}].id`, ""),
            item.split("_")[0],
            "",
            index
          );
      });
    }
  };
  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    id: string,
    entity_parent: any,
    search_text: string,
    index: number
  ) => {
    if (id) {
      let payload = {
        ic_entity_group: id,
        ic_entity_parent: entity_parent,
        limit: 10,
        search_text: search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setChildEntityLoading(true);
      try {
        let resp = await getChildEntityGroupsIC(queryRequest);
        if (resp) {
          levelObj[id] = getValue(resp, `data.icEntityMapping`, []).map(
            (item: any) => ({
              ...item,
              value: getValue(item, `ic_entity_name`, ""),
              label: getValue(item, `ic_entity_name`, ""),
            })
          );
          setLevelObj({ ...levelObj });
          setChildEntityLoading(false);
        } else {
          setChildEntityLoading(false);
        }
      } catch (error) {
        setChildEntityLoading(false);
      }
    } else {
      // toast.error("You have Reached Maximum Levels");
    }
  };
  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(obj, headerIndex);
      } else {
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(obj, headerIndex);
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChange = (
    val: string,
    entity_group: string,
    parent_level: any,
    index: number
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
          "_"
        )[0]
      : null;

    if (!val) {
      getEntityList(entity_group, entityID, "", index);
      let length = Object.keys(paramsObj).length;
      for (let i = parent_level; i <= length; i++) {
        let id =
          paramsObj[`level${i + 1}`] &&
          paramsObj[`level${i + 1}`].split("_")[1];
        if (id) {
          levelObj[id] = {};
        }
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
      getHeaderList(obj, index);
    } else {
      getEntityList(entity_group, entityID, val, index);
    }
  };


  const handleReset = () => {
    setParamsObj({});
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    let first = moment(from_date).format("YYYY-MM-DD");
    let last = moment(to_date).format("YYYY-MM-DD");
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  const handleNavigate = (
    complianceId: string,
    type: string,
    value: String,
    route: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    var firstDay = params.from_date
      ? params.from_date
      : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    var lastDay = params.to_date
      ? params.to_date
      : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

    let payload = {
      ...params,
      request_from: "DASHBOARD",
      request_type: type,
      request_value: value,
      firstDay: moment(firstDay).format("YYYY-MM-DD"),
      lastDay: moment(lastDay).format("YYYY-MM-DD"),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/activities/internal-compliance/${route}?${queryRequest}`);
  };

  const handleSubmitSmartFilter = () => {
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
      }
    }
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      // page_no: getValue(params, `page_no`, ""),
      // search_text: getValue(params, `search_text`, ""),
      // limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
  };

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    setParamsObj({});
    setFilterVisibility(false);
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getDataParamsObj({});
  };
  const getImages = (name: string) => {
    switch (name) {
      case "ASSIGNED":
        return <AssignedSvgComponent />;
      case "POSING":
        return <PosingSvgComponent />;
      case "COMPLIED":
        return <CompliedSvgComponent />;
      case "NON_COMPLIED":
        return <NonCompliedSvgComponent />;
      case "DELAYED":
        return <DelayedSvgComponent />;
      case "DELAYED_REPORTED":
        return <DelayReportedSvgComponent />;
      case "RE_OPENED":
        return <ReopenedSvgComponent />;
      case "TOTAL":
        return <TotalSvgComponent />;
      case "DUE_TODAY":
        return <DueTodaySvgComponent />;
      case "UPCOMING":
        return <UpcomingSvgComponent />;
      case "OVERDUE":
        return <OverdueSvgComponent />;
      case "MY_SUBMISSION_FOR_APPROVAL":
        return <SubmissionApprovalSvgComponent />;
      case "PENDING_FOR_MY_APPROVAL":
        return <PendingApprovalSvgComponent />;
      default:
        return;
    }
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "dashboard_internal_compliance_my_activity"
      ) ? (
        <NoAccessPage />
      ) : isLoading || !props.permissionAPITriggered ? (
        <Loader />
      ) : (
        <>
          {/* <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <h4 className="dashbaord-wrapper__header-title">Internal Activity</h4>
          </div> */}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
						<div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <DashboardSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Internal Compliance
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  My Activity
                </h4>
              </div>
						</div>

            <div className="d-flex">
              <RightMenuHeaders
                smartFilter={true}
                handleFilter={handleFilter}
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
                
              />
              
            </div>
					</div>
          <div className={`main-page-layout-wrapper main-page-layout-wrapper-dashboard`}>
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add={"false"}
                  search={"false"}
                  isFilterVisible={isFilterVisible}
                  filterIsOpen={filterIsOpen}
                  handleFilter={() => {
                    setFilterIsOpen(!filterIsOpen);
                  }}
                />
              </div>
              {/* {isFilterVisible && ( */}
              <DashboardFilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                //-----> Entity Mapping Filter
                headerList={headerList}
                headerLoading={headerLoading}
                levelObj={levelObj}
                childEntityLoading={childEntityLoading}
                handleClickEntity={handleClickEntity}
                urlParams={paramsObj}
                handleChangeEntity={handleChange}
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                moduleName={"Internal Compliance"}
                subModuleName={"My Activity"}
              />
              {/* )} */}
            </div>
            <div className="overview-wrapper_main">
              <div className="overview-wrapper_flex_1">
                <div className="header_section border_bottom p-2 px-4 d-flex justify-content-between">
                  <h3 className="dashboard-compliance__title mt-2">Reports</h3>
                  <div className="filter-form-wrappper__container d-flex align-items-center">
					{/* <div className="no-bordered-input-calendar mr-2">
						<DatePicker
						selectsRange={false}
						selected={from_date ? new Date(from_date) : null}
						className="react-date-picker__inputGroup__input"
						onChange={(date: any) => {
							if (date && to_date && new Date(date) > new Date(to_date)) {
							toast.error("From Date cannot be greater than To Date");
							} else {
							handleDate([date, to_date]);
							}
						}}
						dateFormat="d MMM yyyy"
						showMonthDropdown
						showYearDropdown
						dropdownMode="select"
						placeholderText="Select From Date"
						maxDate={to_date ? new Date(to_date) : undefined}
						/>
					</div> */}
					{/* <div className="no-bordered-input-calendar mr-2">
						<DatePicker
						selectsRange={false}
						selected={to_date ? new Date(to_date) : null}
						className="react-date-picker__inputGroup__input"
						onChange={(date: any) => {
							if (from_date && date && new Date(from_date) > new Date(date)) {
							toast.error("To Date cannot be less than From Date");
							} else {
							handleDate([from_date, date]);
							}
						}}
						dateFormat="d MMM yyyy"
						showMonthDropdown
						showYearDropdown
						dropdownMode="select"
						placeholderText="Select To Date"
						minDate={from_date ? new Date(from_date) : undefined}
						/>
					</div>
					<button
						className="dashboard-wrapper__apply-btn ml-2"
						onClick={handleSubmitDate}
					>
						Apply
					</button> */}
           <RightMenuHeaders
                                // mappedTaskSCExecutor={false}
                                // date range
                                dateRange={true}
                                from_date={from_date}
                                to_date={to_date}
                                handleDate={handleDate}
                                handleSubmitDate={handleSubmitDate}
                                // use license-style separate day pickers
                                licenseStyleCalendar={true}
                                //search
                                // isSearch={true}
          
          
                              />
					</div>
                </div>
                <div className="p-4">
                  <div className="dashboard-compliance">
                    <div className="dashboard-compliance__common d-flex align-items-center justify-content-between">
                      <h3 className="dashboard-compliance__title">
                        Status on Actioned Tasks by Executor
                      </h3>
                      <h3 className="dashboard-compliance__date dashboard-compliance__date--compliance overview-wrapper__header-date d-flex align-items-center"></h3>
                    </div>
                    <div className="d-flex align-items-center box-gap mb-3">
                      {selfActivity.map((obj: any, index: number) => {
                        // if (
                        // 	getValue(obj, `[${getValue(obj, `activity`, "")}].count`, 0)
                        // )
                        return (
                          <section
                            key={index}
                            className={`breakup-box breakup-box--${obj.color} breakup-box--${obj.background}`}
                            // style={{ backgroundColor: random_rgba() }}
                            onClick={() =>
                              getValue(
                                obj,
                                `[${getValue(obj, `activity`, "")}].count`,
                                0
                              ) > 0 &&
                              handleNavigate(
                                getValue(
                                  obj,
                                  `[${getValue(
                                    obj,
                                    `activity`,
                                    ""
                                  )}].compliance_type_id`,
                                  ""
                                ),
                                "SELF_ACTIVITY",
                                getValue(obj, `activity`, ""),
                                "my-task"
                              )
                            }
                          >
                            <div className="breakup-box__details">
                              <h6
                                className={`breakup-box__title breakup-box__title--${obj.color}`}
                              >
                                {getValue(
                                  obj,
                                  `[${getValue(obj, `activity`, "")}].count`,
                                  ""
                                )}
                              </h6>
                              <p
                                className={`breakup-box__text breakup-box__text--${obj.color}`}
                              >
                                {formatText(getValue(obj, `activity`, ""))}
                              </p>
                            </div>

                            <div className="breakup-box-image">
                              {getImages(getValue(obj, `activity`, ""))}
                            </div>
                          </section>
                        );
                      })}
                    </div>
                  </div>
                  <div className="dashboard-compliance">
                    <div className="dashboard-compliance__common d-flex align-items-center justify-content-between">
                      <h3 className="dashboard-compliance__title">
                        Executor Action Items
                      </h3>
                    </div>
                    <div className="dashboard-compliance__closed d-flex align-items-center box-gap mb-3">
                      {complianceReports.map((obj: any, index: number) => {
                        // if(getValue(
                        // 	obj,
                        // 	`[${getValue(obj, `activity`, "")}].count`,
                        // 	""
                        // )> 0)
                        return (
                          <section
                            className={`breakup-box breakup-box--${obj.color} breakup-box--${obj.background}`}
                            // style={{ backgroundColor: random_rgba() }}
                            onClick={() =>
                              getValue(
                                obj,
                                `[${getValue(obj, `activity`, "")}].count`,
                                0
                              ) > 0 &&
                              handleNavigate(
                                "id",
                                "COMPLIANCE_REPORTS",
                                getValue(obj, `activity`, ""),
                                "my-task"
                              )
                            }
                          >
                            <div className="breakup-box__details">
                              <h6
                                className={`breakup-box__title breakup-box__title--${obj.color}`}
                              >
                                {getValue(
                                  obj,
                                  `[${getValue(obj, `activity`, "")}].count`,
                                  ""
                                )}
                              </h6>
                              <p
                                className={`breakup-box__text breakup-box__text--${obj.color}`}
                              >
                                {formatText(getValue(obj, `activity`, ""))}
                              </p>
                            </div>
                            <div className="breakup-box-image">
                              {getImages(getValue(obj, `activity`, ""))}
                            </div>
                          </section>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="overview-wrapper_flex_2 ms-3">
                <div className="header_section border_bottom p-2 px-4">
                  <h3 className="dashboard-compliance__title mt-2">
                    {" "}
                    Approval Stats
                  </h3>
                </div>
                <div className="p-4">
                  <div className="dashboard-compliance__closed d-flex align-items-center box-gap mb-3">
                    {approval_stats.map((obj: any, index: number) => {
                      // if(getValue(
                      // 	obj,
                      // 	`[${getValue(obj, `activity`, "")}].count`,
                      // 	0
                      // ) > 0)
                      return (
                        <div className="border_bottom w-100">
                          <div className="mb-3 ">
                            <section
                              className={`cursor-pointer d-flex align-items-center  breakup-box--${obj.color} breakup-box--${obj.background} `}
                              //   style={{ backgroundColor: random_rgba() }}
                              onClick={() =>
                                getValue(
                                  obj,
                                  `[${getValue(obj, `activity`, "")}].count`,
                                  0
                                ) > 0 &&
                                handleNavigate(
                                  "id",
                                  "APPROVAL_STATS",
                                  getValue(obj, `activity`, ""),
                                  getValue(obj, `activity`, "") ===
                                    "PENDING_FOR_MY_APPROVAL"
                                    ? "pending-approval"
                                    : "my-task"
                                )
                              }
                            >
                              <div>
                                {getImages(getValue(obj, `activity`, ""))}
                              </div>
                              <div className="breakup-box__details ms-3">
                                <h6
                                  className={`breakup-box__title breakup-box__title--${obj.color}`}
                                >
                                  {getValue(
                                    obj,
                                    `[${getValue(obj, `activity`, "")}].count`,
                                    ""
                                  )}
                                </h6>
                                <p
                                  className={`breakup-box__text breakup-box__text--${obj.color}`}
                                >
                                  {formatText(getValue(obj, `activity`, ""))}
                                </p>
                              </div>
                              <img
                                src={obj.image}
                                className="img-fluid breakup-box-image"
                              />
                            </section>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="text-right">
              <img src="/images/profile-illustration.svg" className="img-fluid" />
            </div> */}
          </div>
        </>
      )}
    </DashboardLayout>
  );
}
